var _rect, _rect2, _rect3, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 33,
    rx: 16.5,
    fill: "#F9F9FB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 33,
    rx: 16.5,
    stroke: "#D8D9E0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_17_179",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 24,
    height: 24
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_17_179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3962 17L12.4155 11.4307C12.2398 11.1807 12.2187 10.9215 12.352 10.653C12.4853 10.3843 12.7064 10.25 13.0152 10.25C13.1389 10.25 13.2563 10.2782 13.3675 10.3345C13.4787 10.3908 13.5652 10.4691 13.627 10.5693L18.2307 17L13.627 23.4307C13.565 23.5309 13.4782 23.6092 13.3667 23.6655C13.2551 23.7218 13.1373 23.75 13.0135 23.75C12.716 23.75 12.4981 23.6157 12.3597 23.347C12.2212 23.0785 12.2398 22.8193 12.4155 22.5693L16.3962 17ZM22.2692 17L18.2885 11.4307C18.1128 11.1807 18.0917 10.9215 18.225 10.653C18.3583 10.3843 18.5794 10.25 18.8882 10.25C19.0119 10.25 19.1293 10.2782 19.2405 10.3345C19.3517 10.3908 19.4382 10.4691 19.5 10.5693L24.1037 17L19.5 23.4307C19.438 23.5309 19.3512 23.6092 19.2397 23.6655C19.1282 23.7218 19.0105 23.75 18.8865 23.75C18.5892 23.75 18.3712 23.6157 18.2327 23.347C18.0942 23.0785 18.1128 22.8193 18.2885 22.5693L22.2692 17Z",
    fill: "#1C1B1F"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/ArrowRight.d9071050178680917c065d583f55b631.svg";
export { ForwardRef as ReactComponent };